// src/composables/useEnv.js
import { ref, onMounted } from 'vue'

// 创建一个全局的 ref
const isWeChat = ref(false)

// 立即执行检测
const userAgent = navigator.userAgent.toLowerCase()
const keywords = ['micromessenger', 'wechat'].map(key => key.toLowerCase())
isWeChat.value = keywords.some(keyword => userAgent.includes(keyword))

export function useEnv() {
  return {
    isWeChat,
  }
}
